<template>
  <WorkTableDialog
    ref='currencySelectDialog'
    path="system/currencies"
    :headers="headers"
    :get-data="getData"
    title="Währung"
  />
</template>

<script>
import WorkTableDialog from '@/components/base_components/dialog/table_dialogs/WorkTableDialog';
import { getSymbol } from '@/services/formatter_services/currency-formatter';

export default {
  name: 'WorkCurrencyDialog',
  components: { WorkTableDialog },
  data() {
    return {
      headers: [
        { text: this.$t('Common.label'), value: 'data.label' },
        { text: 'ISO-Code', value: 'data.isoCode'},
        { text: this.$t('Common.symbol'), value: 'data.symbol', presentWith: getSymbol }
      ],
    };
  },
  methods: {
    open() {
      return this.$refs.currencySelectDialog.open();
    },
    getData(response) {
      response.data.data.map(currency => { 
        currency.data.isoCode = currency.data.symbol; 
        return currency
      })
      return response.data.data
    },
  }
};
</script>
